
import React from 'react';
import { Info } from 'lucide-react';

interface FAQ {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  faqs: FAQ[];
}

const FAQSection: React.FC<FAQSectionProps> = ({ faqs }) => {
  return (
    <section id="faq" className="px-4 py-16 bg-optout-gray bg-opacity-50">
      <div className="container mx-auto max-w-3xl">
        <div className="text-center mb-12 animate-fade-in">
          <div className="inline-flex items-center justify-center space-x-2 mb-4">
            <Info className="h-5 w-5 text-optout-blue" />
            <span className="font-medium text-optout-blue">FAQ</span>
          </div>
          
          <h2 className="text-2xl md:text-3xl font-bold text-optout-text mb-4">
            Frequently Asked Questions
          </h2>
          
          <p className="text-optout-lighttext max-w-2xl mx-auto text-balance">
            Find answers to commonly asked questions about opting out of SMS messages.
          </p>
        </div>
        
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="glass-card rounded-xl p-6 animate-fade-in" 
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <h3 className="text-lg font-medium text-optout-text mb-2">
                {faq.question}
              </h3>
              <p className="text-optout-lighttext">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
